import { querySelectorURL } from "../../cpcoc/querySelectorURL";
import { getDates, setDates } from "./dates";
import { setReadingPlan } from "./readingPlan";
import { setTemplates } from "./templates";
import { setReadingViewType } from "./setReadingViewType";
import { setOutsideCalendar } from "./setOutsideCalendar";
import { getCurrentDate, initCurrentDate } from "../../cpcoc/currentDate";
import { refreshContent } from "./refreshContent";
import { configureDatabase } from "../../main/data/data-read-only";
import { getPageEntry } from "./pageEntry";
export function buildBibleReading() {
    initCurrentDate(querySelectorURL("mockDate"));
    const currentDate = getCurrentDate(); // for testing as the actual date
    const dateToInitQuery = querySelectorURL("date"); // for pagination date override looking ahead // This is what date we are looking at on the calendar itself
    const readingPlanIdQuery = querySelectorURL("id");
    const dateToInit = new Date(typeof dateToInitQuery === "string" ? dateToInitQuery : currentDate); // convert to date, and add fallback
    const readingPlanId = typeof readingPlanIdQuery === "string"
        ? readingPlanIdQuery
        : "daily-bible-reading"; // adding fallback
    currentDate.setHours(0, 0, 0);
    dateToInit.setHours(0, 0, 0);
    configureDatabase();
    // TODO: can this function handle all of this logic?
    setReadingViewType(querySelectorURL("type") ||
        window.localStorage.getItem("type"), { ignoreRefresh: true });
    setDates(dateToInit, { ignoreRefresh: true });
    setReadingPlan(readingPlanId).then((readingPlan) => {
        setOutsideCalendar((querySelectorURL("outsideCalendar") ||
            window.localStorage.getItem("outsideCalendar") ||
            readingPlan.style.outsideCalendar ||
            false), { ignoreRefresh: true });
        setTemplates();
        refreshContent();
    });
    getPageEntry().addEventListener("click", (e) => {
        const target = e.target;
        const classList = target.classList;
        if (classList.contains("bible-reading__types-btn")) {
            setReadingViewType(target.getAttribute("value"));
        }
        if (classList.contains("bible-reading__print-btn")) {
            window.print();
        }
        if (classList.contains("bible-reading__outside-calendar-toggle")) {
            setOutsideCalendar(target.getAttribute("value"));
        }
        if (classList.contains("bible-reading__type-title")) {
            setDates(currentDate);
        }
        else if (classList.contains("bible-reading__paginate-btn") &&
            target.nodeName !== "A") {
            setDates(getDates()[target.getAttribute("value")]);
        }
    });
}
